import { Route } from 'react-router-dom';
import { LoginView } from 'src/features/access/views/login.view';
import { CalendarView } from 'src/features/booking/views/calendar.view';
import { CustomerAnalysisView } from 'src/features/customer/views/customer.analysis.view';
import { CustomersView } from 'src/features/customer/views/customer.view';
import { CustomerWorkoutSessionSetsView } from 'src/features/customer/views/customer.workout.session.sets.view';
import { SessionsView } from 'src/features/customer/views/sessions.view';
import { CustomerWorkoutsCreateView } from 'src/features/customer/views/customer.workouts.create.view';
import { CustomerWorkoutsView } from 'src/features/customer/views/customer.workouts.view';
import { ExercisesView } from 'src/features/exercise/views/exercise.view';
import { HomeView } from 'src/features/home/views/home.view';
import { WorkoutsView } from 'src/features/workout/views/workouts.view';
import { WorkoutSessionsView } from 'src/features/customer/views/workout.sessions.view';
import { CustomerSessionsView } from 'src/features/customer/views/customer.sessions';
import { CustomerWorkoutsArchivedView } from 'src/features/customer/views/customer.workouts.archive.view';
import { SalesView } from 'src/features/sales/views/sales.view';

export enum RouteEnum {
    home = '/home',
    login = '/login',
    calendar = '/calendar',
    bookings = '/bookings',
    exercises = '/exercises',
    workouts = '/workouts',
    sessions = '/sessions',
    workoutSessions = '/workoutSessions',
    workoutSessionsSets = '/workoutSession/sets',
    customers = '/customers',
    customersDetails = '/customers/detail',
    customersAnalysis = '/customers/analysis',
    customersWorkouts = '/customers/workouts',
    customersWorkoutsArchived = '/customers/workouts/archived',
    customersSessions = '/customers/sessions',
    customersWorkoutsCreate = '/customers/workouts/create',
    sales = '/sales'
}

export const PUBLIC_ROUTES = [] as const;

export const PRIVATE_ROUTES = [
    { id: 'home', path: RouteEnum.home, component: HomeView },
    { id: 'login', path: RouteEnum.login, component: LoginView },
    { id: 'calendar', path: RouteEnum.calendar, component: CalendarView },
    { id: 'customers', path: RouteEnum.customers, component: CustomersView },
    { id: 'customersDetails', path: RouteEnum.customersDetails, component: CustomersView },
    { id: 'customersAnalysis', path: RouteEnum.customersAnalysis, component: CustomerAnalysisView },
    { id: 'workouts', path: RouteEnum.workouts, component: WorkoutsView },
    { id: 'sessions', path: RouteEnum.sessions, component: SessionsView },
    { id: 'customerSessions', path: RouteEnum.customersSessions, component: CustomerSessionsView },
    { id: 'workoutSessions', path: RouteEnum.workoutSessions, component: WorkoutSessionsView },
    { id: 'workoutSessionsSets', path: RouteEnum.workoutSessionsSets, component: CustomerWorkoutSessionSetsView },
    { id: 'exercises', path: RouteEnum.exercises, component: ExercisesView },
    { id: 'customersWorkouts', path: RouteEnum.customersWorkouts, component: CustomerWorkoutsView },
    { id: 'customersWorkoutsArchived', path: RouteEnum.customersWorkoutsArchived, component: CustomerWorkoutsArchivedView },
    { id: 'customersWorkoutsCreate', path: RouteEnum.customersWorkoutsCreate, component: CustomerWorkoutsCreateView },
    { id: 'sales', path: RouteEnum.sales, component: SalesView },
] as const;

const routes = [...PUBLIC_ROUTES, ...PRIVATE_ROUTES] as const;

const GuardRoute: React.FC<any> = ({ path, component }) => {
    return <Route exact path={path} component={component} />;
};

export const PublicRoutes = () => (
    <>
        {PUBLIC_ROUTES.map(({ path, component }) => (
            <Route key={path} path={path} component={component} />
        ))}
    </>
);

export const PrivateRoutes = () => {
    return (
        <>
            {PRIVATE_ROUTES.map(({ path, component }) => (
                <GuardRoute key={path} path={path} component={component} />
            ))}
        </>
    );
};

export type Paths = (typeof routes)[number]['path'];
